//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ConfigurableMonitoringFormsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMonitoringFormConfigsConfigurableMonitoringFormsQueryParameters = {
  studyId?: number | null;
  formIds?: number[] | null | null;
};

export type GetMonitoringFormConfigConfigurableMonitoringFormsQueryParameters = {
  formId: number;
};

export type GetMonitoringFormResultsConfigurableMonitoringFormsQueryParameters = {
  formId?: number | null;
};

export type GetMonitoringFormResultsForListConfigurableMonitoringFormsQueryParameters = {
  formId?: number | null;
};

export type GetMonitoringFormResultConfigurableMonitoringFormsQueryParameters = {
  resultId: number;
};

export type UploadConfigFileConfigurableMonitoringFormsMutationParameters = {
  file?: Types.FileParameter | null | undefined ; 
};

export type UploadResultFileConfigurableMonitoringFormsMutationParameters = {
  file?: Types.FileParameter | null | undefined ; 
};

    
export function getMonitoringFormConfigsUrl(studyId?: number | undefined, formIds?: number[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (formIds !== undefined && formIds !== null)
    formIds && formIds.forEach(item => { url_ += "formIds=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormConfigsDefaultOptions: UseQueryOptions<Types.MonitoringFormConfigDto[], unknown, Types.MonitoringFormConfigDto[]> = {
  queryFn: __getMonitoringFormConfigs,
};
export function getGetMonitoringFormConfigsDefaultOptions(): UseQueryOptions<Types.MonitoringFormConfigDto[], unknown, Types.MonitoringFormConfigDto[]> {
  return getMonitoringFormConfigsDefaultOptions;
};
export function setGetMonitoringFormConfigsDefaultOptions(options: UseQueryOptions<Types.MonitoringFormConfigDto[], unknown, Types.MonitoringFormConfigDto[]>) {
  getMonitoringFormConfigsDefaultOptions = options;
}

export function getMonitoringFormConfigsQueryKey(dto: GetMonitoringFormConfigsConfigurableMonitoringFormsQueryParameters): QueryKey;
export function getMonitoringFormConfigsQueryKey(studyId?: number | undefined, formIds?: number[] | null | undefined): QueryKey;
export function getMonitoringFormConfigsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, formIds,  } = params[0] as GetMonitoringFormConfigsConfigurableMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormConfigs',
        studyId as any,
        formIds as any,
      ]);
  } else {
    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormConfigs',
        ...params
      ]);
  }
}
function __getMonitoringFormConfigs(context: QueryFunctionContext) {
  return Client.getMonitoringFormConfigs(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number[] | null | undefined    );
}

export function useGetMonitoringFormConfigsQuery<TSelectData = Types.MonitoringFormConfigDto[], TError = unknown>(dto: GetMonitoringFormConfigsConfigurableMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.MonitoringFormConfigDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormConfigsQuery<TSelectData = Types.MonitoringFormConfigDto[], TError = unknown>(studyId?: number | undefined, formIds?: number[] | null | undefined, options?: UseQueryOptions<Types.MonitoringFormConfigDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormConfigsQuery<TSelectData = Types.MonitoringFormConfigDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MonitoringFormConfigDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let formIds: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, formIds,  } = params[0] as GetMonitoringFormConfigsConfigurableMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, formIds, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MonitoringFormConfigDto[], TError, TSelectData>({
    queryFn: __getMonitoringFormConfigs,
    queryKey: getMonitoringFormConfigsQueryKey(studyId, formIds),
    ...getMonitoringFormConfigsDefaultOptions as unknown as UseQueryOptions<Types.MonitoringFormConfigDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormConfigsData(queryClient: QueryClient, updater: (data: Types.MonitoringFormConfigDto[] | undefined) => Types.MonitoringFormConfigDto[], studyId?: number | undefined, formIds?: number[] | null | undefined) {
  queryClient.setQueryData(getMonitoringFormConfigsQueryKey(studyId, formIds),
    updater
  );
}

export function setGetMonitoringFormConfigsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MonitoringFormConfigDto[] | undefined) => Types.MonitoringFormConfigDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createMonitoringFormsConfigUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMonitoringFormsConfigMutationKey(studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'createMonitoringFormsConfig',
      studyId as any,
    ]);
}

export function useCreateMonitoringFormsConfigMutation<TContext>(studyId?: number | undefined, options?: Omit<UseMutationOptions<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigCreationDto, TContext> {
  const key = createMonitoringFormsConfigMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.MonitoringFormConfigCreationDto) => Client.createMonitoringFormsConfig(dto, studyId), {...options, mutationKey: key});
}
  
    
export function getMonitoringFormConfigUrl(formId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
if (formId === undefined || formId === null)
  throw new Error("The parameter 'formId' must be defined.");
url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormConfigDefaultOptions: UseQueryOptions<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigDto> = {
  queryFn: __getMonitoringFormConfig,
};
export function getGetMonitoringFormConfigDefaultOptions(): UseQueryOptions<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigDto> {
  return getMonitoringFormConfigDefaultOptions;
};
export function setGetMonitoringFormConfigDefaultOptions(options: UseQueryOptions<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigDto>) {
  getMonitoringFormConfigDefaultOptions = options;
}

export function getMonitoringFormConfigQueryKey(formId: number): QueryKey;
export function getMonitoringFormConfigQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { formId,  } = params[0] as GetMonitoringFormConfigConfigurableMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormConfig',
        formId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormConfig',
        ...params
      ]);
  }
}
function __getMonitoringFormConfig(context: QueryFunctionContext) {
  return Client.getMonitoringFormConfig(
      context.queryKey[2] as number    );
}

export function useGetMonitoringFormConfigQuery<TSelectData = Types.MonitoringFormConfigDto, TError = unknown>(dto: GetMonitoringFormConfigConfigurableMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.MonitoringFormConfigDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormConfigQuery<TSelectData = Types.MonitoringFormConfigDto, TError = unknown>(formId: number, options?: UseQueryOptions<Types.MonitoringFormConfigDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormConfigQuery<TSelectData = Types.MonitoringFormConfigDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MonitoringFormConfigDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let formId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ formId,  } = params[0] as GetMonitoringFormConfigConfigurableMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [formId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MonitoringFormConfigDto, TError, TSelectData>({
    queryFn: __getMonitoringFormConfig,
    queryKey: getMonitoringFormConfigQueryKey(formId),
    ...getMonitoringFormConfigDefaultOptions as unknown as UseQueryOptions<Types.MonitoringFormConfigDto, TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormConfigData(queryClient: QueryClient, updater: (data: Types.MonitoringFormConfigDto | undefined) => Types.MonitoringFormConfigDto, formId: number) {
  queryClient.setQueryData(getMonitoringFormConfigQueryKey(formId),
    updater
  );
}

export function setGetMonitoringFormConfigDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MonitoringFormConfigDto | undefined) => Types.MonitoringFormConfigDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function patchMonitoringFormsConfigUrl(formId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
if (formId === undefined || formId === null)
  throw new Error("The parameter 'formId' must be defined.");
url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMonitoringFormsConfigMutationKey(formId: number): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'patchMonitoringFormsConfig',
      formId as any,
    ]);
}

export function usePatchMonitoringFormsConfigMutation<TContext>(formId: number, options?: Omit<UseMutationOptions<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigPatchingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MonitoringFormConfigDto, unknown, Types.MonitoringFormConfigPatchingDto, TContext> {
  const key = patchMonitoringFormsConfigMutationKey(formId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.MonitoringFormConfigPatchingDto) => Client.patchMonitoringFormsConfig(formId, dto), {...options, mutationKey: key});
}
  
    
export function removeMonitoringFormsConfigUrl(formId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/configs/{formId}";
if (formId === undefined || formId === null)
  throw new Error("The parameter 'formId' must be defined.");
url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMonitoringFormsConfigMutationKey(formId: number): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'removeMonitoringFormsConfig',
      formId as any,
    ]);
}

export function useRemoveMonitoringFormsConfigMutation<TContext>(formId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMonitoringFormsConfigMutationKey(formId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeMonitoringFormsConfig(formId), {...options, mutationKey: key});
}
  
    
export function getMonitoringFormResultsUrl(formId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results?";
if (formId === null)
    throw new Error("The parameter 'formId' cannot be null.");
else if (formId !== undefined)
    url_ += "formId=" + encodeURIComponent("" + formId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormResultsDefaultOptions: UseQueryOptions<Types.MonitoringFormResultDto[], unknown, Types.MonitoringFormResultDto[]> = {
  queryFn: __getMonitoringFormResults,
};
export function getGetMonitoringFormResultsDefaultOptions(): UseQueryOptions<Types.MonitoringFormResultDto[], unknown, Types.MonitoringFormResultDto[]> {
  return getMonitoringFormResultsDefaultOptions;
};
export function setGetMonitoringFormResultsDefaultOptions(options: UseQueryOptions<Types.MonitoringFormResultDto[], unknown, Types.MonitoringFormResultDto[]>) {
  getMonitoringFormResultsDefaultOptions = options;
}

export function getMonitoringFormResultsQueryKey(formId?: number | undefined): QueryKey;
export function getMonitoringFormResultsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { formId,  } = params[0] as GetMonitoringFormResultsConfigurableMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResults',
        formId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResults',
        ...params
      ]);
  }
}
function __getMonitoringFormResults(context: QueryFunctionContext) {
  return Client.getMonitoringFormResults(
      context.queryKey[2] as number | undefined    );
}

export function useGetMonitoringFormResultsQuery<TSelectData = Types.MonitoringFormResultDto[], TError = unknown>(dto: GetMonitoringFormResultsConfigurableMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.MonitoringFormResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormResultsQuery<TSelectData = Types.MonitoringFormResultDto[], TError = unknown>(formId?: number | undefined, options?: UseQueryOptions<Types.MonitoringFormResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormResultsQuery<TSelectData = Types.MonitoringFormResultDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MonitoringFormResultDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let formId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ formId,  } = params[0] as GetMonitoringFormResultsConfigurableMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [formId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MonitoringFormResultDto[], TError, TSelectData>({
    queryFn: __getMonitoringFormResults,
    queryKey: getMonitoringFormResultsQueryKey(formId),
    ...getMonitoringFormResultsDefaultOptions as unknown as UseQueryOptions<Types.MonitoringFormResultDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormResultsData(queryClient: QueryClient, updater: (data: Types.MonitoringFormResultDto[] | undefined) => Types.MonitoringFormResultDto[], formId?: number | undefined) {
  queryClient.setQueryData(getMonitoringFormResultsQueryKey(formId),
    updater
  );
}

export function setGetMonitoringFormResultsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MonitoringFormResultDto[] | undefined) => Types.MonitoringFormResultDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function processNewMonitoringFormResultUrl(formId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results?";
if (formId === null)
    throw new Error("The parameter 'formId' cannot be null.");
else if (formId !== undefined)
    url_ += "formId=" + encodeURIComponent("" + formId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processNewMonitoringFormResultMutationKey(formId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'processNewMonitoringFormResult',
      formId as any,
    ]);
}

export function useProcessNewMonitoringFormResultMutation<TContext>(formId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.MonitoringFormProcessingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MonitoringFormProcessingDto, TContext> {
  const key = processNewMonitoringFormResultMutationKey(formId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.MonitoringFormProcessingDto) => Client.processNewMonitoringFormResult(dto, formId), {...options, mutationKey: key});
}
  
    
export function getMonitoringFormResultsForListUrl(formId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/forList?";
if (formId === null)
    throw new Error("The parameter 'formId' cannot be null.");
else if (formId !== undefined)
    url_ += "formId=" + encodeURIComponent("" + formId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormResultsForListDefaultOptions: UseQueryOptions<Types.ShortMonitoringFormResultDto[], unknown, Types.ShortMonitoringFormResultDto[]> = {
  queryFn: __getMonitoringFormResultsForList,
};
export function getGetMonitoringFormResultsForListDefaultOptions(): UseQueryOptions<Types.ShortMonitoringFormResultDto[], unknown, Types.ShortMonitoringFormResultDto[]> {
  return getMonitoringFormResultsForListDefaultOptions;
};
export function setGetMonitoringFormResultsForListDefaultOptions(options: UseQueryOptions<Types.ShortMonitoringFormResultDto[], unknown, Types.ShortMonitoringFormResultDto[]>) {
  getMonitoringFormResultsForListDefaultOptions = options;
}

export function getMonitoringFormResultsForListQueryKey(formId?: number | undefined): QueryKey;
export function getMonitoringFormResultsForListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { formId,  } = params[0] as GetMonitoringFormResultsForListConfigurableMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResultsForList',
        formId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResultsForList',
        ...params
      ]);
  }
}
function __getMonitoringFormResultsForList(context: QueryFunctionContext) {
  return Client.getMonitoringFormResultsForList(
      context.queryKey[2] as number | undefined    );
}

export function useGetMonitoringFormResultsForListQuery<TSelectData = Types.ShortMonitoringFormResultDto[], TError = unknown>(dto: GetMonitoringFormResultsForListConfigurableMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.ShortMonitoringFormResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormResultsForListQuery<TSelectData = Types.ShortMonitoringFormResultDto[], TError = unknown>(formId?: number | undefined, options?: UseQueryOptions<Types.ShortMonitoringFormResultDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormResultsForListQuery<TSelectData = Types.ShortMonitoringFormResultDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ShortMonitoringFormResultDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let formId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ formId,  } = params[0] as GetMonitoringFormResultsForListConfigurableMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [formId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.ShortMonitoringFormResultDto[], TError, TSelectData>({
    queryFn: __getMonitoringFormResultsForList,
    queryKey: getMonitoringFormResultsForListQueryKey(formId),
    ...getMonitoringFormResultsForListDefaultOptions as unknown as UseQueryOptions<Types.ShortMonitoringFormResultDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormResultsForListData(queryClient: QueryClient, updater: (data: Types.ShortMonitoringFormResultDto[] | undefined) => Types.ShortMonitoringFormResultDto[], formId?: number | undefined) {
  queryClient.setQueryData(getMonitoringFormResultsForListQueryKey(formId),
    updater
  );
}

export function setGetMonitoringFormResultsForListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ShortMonitoringFormResultDto[] | undefined) => Types.ShortMonitoringFormResultDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getMonitoringFormResultUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormResultDefaultOptions: UseQueryOptions<Types.MonitoringFormResultDto, unknown, Types.MonitoringFormResultDto> = {
  queryFn: __getMonitoringFormResult,
};
export function getGetMonitoringFormResultDefaultOptions(): UseQueryOptions<Types.MonitoringFormResultDto, unknown, Types.MonitoringFormResultDto> {
  return getMonitoringFormResultDefaultOptions;
};
export function setGetMonitoringFormResultDefaultOptions(options: UseQueryOptions<Types.MonitoringFormResultDto, unknown, Types.MonitoringFormResultDto>) {
  getMonitoringFormResultDefaultOptions = options;
}

export function getMonitoringFormResultQueryKey(resultId: number): QueryKey;
export function getMonitoringFormResultQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { resultId,  } = params[0] as GetMonitoringFormResultConfigurableMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResult',
        resultId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ConfigurableMonitoringFormsClient',
        'getMonitoringFormResult',
        ...params
      ]);
  }
}
function __getMonitoringFormResult(context: QueryFunctionContext) {
  return Client.getMonitoringFormResult(
      context.queryKey[2] as number    );
}

export function useGetMonitoringFormResultQuery<TSelectData = Types.MonitoringFormResultDto, TError = unknown>(dto: GetMonitoringFormResultConfigurableMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.MonitoringFormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormResultQuery<TSelectData = Types.MonitoringFormResultDto, TError = unknown>(resultId: number, options?: UseQueryOptions<Types.MonitoringFormResultDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormResultQuery<TSelectData = Types.MonitoringFormResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MonitoringFormResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let resultId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ resultId,  } = params[0] as GetMonitoringFormResultConfigurableMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [resultId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MonitoringFormResultDto, TError, TSelectData>({
    queryFn: __getMonitoringFormResult,
    queryKey: getMonitoringFormResultQueryKey(resultId),
    ...getMonitoringFormResultDefaultOptions as unknown as UseQueryOptions<Types.MonitoringFormResultDto, TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormResultData(queryClient: QueryClient, updater: (data: Types.MonitoringFormResultDto | undefined) => Types.MonitoringFormResultDto, resultId: number) {
  queryClient.setQueryData(getMonitoringFormResultQueryKey(resultId),
    updater
  );
}

export function setGetMonitoringFormResultDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MonitoringFormResultDto | undefined) => Types.MonitoringFormResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function removeMonitoringFormResultUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMonitoringFormResultMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'removeMonitoringFormResult',
      resultId as any,
    ]);
}

export function useRemoveMonitoringFormResultMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMonitoringFormResultMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeMonitoringFormResult(resultId), {...options, mutationKey: key});
}
  
    
export function processNewMonitoringFormResultVersionUrl(resultId: number): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/results/{resultId}/versions";
if (resultId === undefined || resultId === null)
  throw new Error("The parameter 'resultId' must be defined.");
url_ = url_.replace("{resultId}", encodeURIComponent("" + resultId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function processNewMonitoringFormResultVersionMutationKey(resultId: number): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'processNewMonitoringFormResultVersion',
      resultId as any,
    ]);
}

export function useProcessNewMonitoringFormResultVersionMutation<TContext>(resultId: number, options?: Omit<UseMutationOptions<void, unknown, Types.MonitoringFormProcessingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MonitoringFormProcessingDto, TContext> {
  const key = processNewMonitoringFormResultVersionMutationKey(resultId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.MonitoringFormProcessingDto) => Client.processNewMonitoringFormResultVersion(resultId, dto), {...options, mutationKey: key});
}
  
    
export function uploadConfigFileUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/files/config/upload?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function uploadConfigFileMutationKey(studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'uploadConfigFile',
      studyId as any,
    ]);
}

export function useUploadConfigFileMutation<TContext>(studyId?: number | undefined, options?: Omit<UseMutationOptions<string, unknown, UploadConfigFileConfigurableMonitoringFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, UploadConfigFileConfigurableMonitoringFormsMutationParameters, TContext> {
  const key = uploadConfigFileMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((uploadConfigFileConfigurableMonitoringFormsMutationParameters: UploadConfigFileConfigurableMonitoringFormsMutationParameters) => Client.uploadConfigFile(studyId, uploadConfigFileConfigurableMonitoringFormsMutationParameters.file), {...options, mutationKey: key});
}
  
    
export function uploadResultFileUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/configurableMonitoringForms/files/results/upload?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function uploadResultFileMutationKey(studyId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'ConfigurableMonitoringFormsClient',
      'uploadResultFile',
      studyId as any,
    ]);
}

export function useUploadResultFileMutation<TContext>(studyId?: number | undefined, options?: Omit<UseMutationOptions<string, unknown, UploadResultFileConfigurableMonitoringFormsMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, UploadResultFileConfigurableMonitoringFormsMutationParameters, TContext> {
  const key = uploadResultFileMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((uploadResultFileConfigurableMonitoringFormsMutationParameters: UploadResultFileConfigurableMonitoringFormsMutationParameters) => Client.uploadResultFile(studyId, uploadResultFileConfigurableMonitoringFormsMutationParameters.file), {...options, mutationKey: key});
}